export const visitorInfo = async () => {
  try {
    const res = await fetch("https://ipwho.is/");
    const data = await res.json();

    return {
      ip: data.ip,
      country: data.country,
      city: data.city,
      region: data.region,
      latitude: data.latitude,
      longitude: data.longitude
    };
  } catch (error) {
    console.error("IP fetch failed:", error);
    return null;
  }
  };